import React, { useEffect, useState } from "react";
import { InputTextArea } from "../../../../../../components/Form";
import { IProps } from "./interfaces";

import { InputTextAreaWrapper } from "./styles";

const TranslationTextArea = ({
    saveToken,
    translationToken,
    original,
    disabled,
    getToken,
    isCorrecting,
    approvedBy,
    maxLength,
}: IProps) => {
    const [text, changeText] = useState(translationToken?.value || "");
    const [isEditing, changeEditing] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const handleChange = ({ currentTarget: { value } }: React.FormEvent<HTMLTextAreaElement>) => {
        changeText(value);
    };
    const value = isEditing ? text : translationToken?.value || "";

    const handleBlur = async () => {
        if (maxLength && value.length > maxLength) return;
        setIsSaving(true);
        await saveToken(text);
        changeEditing(false);
        setIsSaving(false);
    };
    const handleFocus = () => {
        getToken();
        changeEditing(true);
    };
    useEffect(() => {
        if (isCorrecting) {
            changeText(translationToken?.value || "");
        }
    }, [isCorrecting]);
    useEffect(() => {
        changeText(translationToken?.value || "");
    }, [translationToken?.updated, translationToken?.created]);
    return (
        <InputTextAreaWrapper isSaving={isSaving} isCompleted={approvedBy.length > 0}>
            <InputTextArea
                disabled={disabled || isSaving}
                height="auto"
                rows={Math.ceil(original.length / 60)}
                value={value}
                onBlur={handleBlur}
                onFocus={handleFocus}
                onChange={handleChange}
                placeholder="Enter your translation here"
                validation={maxLength && value.length > maxLength ? "maxLength" : null}
                messageLength={maxLength}
            />
        </InputTextAreaWrapper>
    );
};

export default TranslationTextArea;
